import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

import type { DraftReplyMode } from '../mailclient/interface';
import { buildQuickQuoteReplyWirePayload } from './quickQuoteReplyWire';

interface CreateQuickQuoteReplyDraft {
  threadItemId: string;
  draftBody: string;
  replyMode: DraftReplyMode;
  to?: string[];
  cc?: string[];
  bcc?: string[];
}

export async function createQuickQuoteReplyDraft({
  threadItemId,
  draftBody,
  replyMode,
  to,
  cc,
  bcc,
}: CreateQuickQuoteReplyDraft): Promise<Result<null, ApiError>> {
  try {
    const response = await axios.post<null>(
      `/quote/private/quickquote/draft`,
      buildQuickQuoteReplyWirePayload(
        {
          threadItemId,
          draftBody,
          replyMode,
          to,
          cc,
          bcc,
        },
        axios.defaults.baseURL
      )
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'createQuickQuoteReplyDraft' });

    if (!isAxiosError(error)) {
      return err({
        message: 'Unable to create draft reply.',
      });
    }

    if (error && isAxiosError(error) && error.response?.status === 401) {
      throw error;
    }

    if (error && error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message: error.response?.data.message || 'Unable to create draft reply.',
      changes: error.response?.data.changes,
    });
  }
}
